/** Fellido · Ankündigungsleiste — sanftes Wechseln, pausiert bei Hover und im Hintergrund. */
class FAnnounce extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-f-ann-slide]')];
    if (this.slides.length < 2) return;
    this.index = 0;
    this.intervall = (Number(this.dataset.interval) || 5) * 1000;

    this.querySelector('[data-f-ann-next]')?.addEventListener('click', () => this.zeige(this.index + 1, true));
    this.querySelector('[data-f-ann-prev]')?.addEventListener('click', () => this.zeige(this.index - 1, true));
    this.addEventListener('mouseenter', () => this.stopp());
    this.addEventListener('mouseleave', () => this.start());
    document.addEventListener('visibilitychange', () => (document.hidden ? this.stopp() : this.start()));

    this.start();
  }

  disconnectedCallback() {
    this.stopp();
  }

  start() {
    this.stopp();
    this.timer = setInterval(() => this.zeige(this.index + 1), this.intervall);
  }

  stopp() {
    clearInterval(this.timer);
  }

  zeige(ziel, manuell) {
    const anzahl = this.slides.length;
    const neu = ((ziel % anzahl) + anzahl) % anzahl;
    if (neu === this.index) return;
    this.slides[this.index].classList.remove('is-active');
    this.slides[this.index].classList.add('is-out');
    const alt = this.slides[this.index];
    setTimeout(() => alt.classList.remove('is-out'), 350);
    this.slides[neu].classList.add('is-active');
    this.index = neu;
    if (manuell) this.start();
  }
}

if (!customElements.get('f-announce')) customElements.define('f-announce', FAnnounce);
